import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Receivable } from '../../interface/receivable/receivable';
import { HttpService } from '../http/http.service';
import { Customer } from '../../interface';


@Injectable({
  providedIn: 'root'
})
export class ReceivableService {


  constructor(private _httpReceivable: HttpService) { }

  get(): Promise<any> {
    return firstValueFrom(this._httpReceivable.get('/SaleInvoices/Payments'));
  }

  getArrears(params?: { townId?: number; routeId?: number }): Promise<any> {
    const query = new URLSearchParams({ size: '-1' });
    if (params?.townId) query.set('townId', String(params.townId));
    if (params?.routeId) query.set('routeId', String(params.routeId));
    return firstValueFrom(this._httpReceivable.get(`/SaleInvoices/Payments?${query}`));
  }
  sendReceivableRecord(data: Receivable): Promise<any> {
    return firstValueFrom(this._httpReceivable.post('/SaleInvoices/Payments', data));
  }
  update(data: Receivable): Promise<any> {
    return firstValueFrom(this._httpReceivable.post('/SaleInvoices/Payments/', data));
  }
  payList(data: Receivable[]): Promise<any> {
    return firstValueFrom(this._httpReceivable.post('/SaleInvoices/Payments/bulk', data));
  }

  public  async getReceivableHaedList():Promise<any> {
    return (await firstValueFrom(this._httpReceivable.get('/SaleInvoices/Payments?number=1&size=999999')));
  }
  // getReceivableHaedList(){
  //   return this._httpReceivable.get('/Receivable/payments');
  // }
}

